import React from 'react';
import { Icon } from '@gerdau/hefesto';
import {
  BpAddress,
  BpName,
  CaretWrapper,
  Content,
  FieldLabel,
  Trigger,
  Wrapper
} from './styles';

interface BpRichDisplayProps {
  fieldLabel: string;
  name?: string;
  address?: string;
  placeholder?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const BpRichDisplay: React.FC<BpRichDisplayProps> = ({
  fieldLabel,
  name,
  address,
  placeholder = 'Selecione uma opção',
  disabled,
  onClick
}) => (
  <Wrapper>
    <FieldLabel>{fieldLabel}</FieldLabel>
    <Trigger disabled={disabled} onClick={disabled ? undefined : onClick}>
      <Content>
        <BpName isEmpty={!name}>{name || placeholder}</BpName>
        <BpAddress>{address || 'Endereço: --'}</BpAddress>
      </Content>
      <CaretWrapper disabled={disabled}>
        <Icon option="CaretDown" size="sm" />
      </CaretWrapper>
    </Trigger>
  </Wrapper>
);

export default BpRichDisplay;
